import Local from './local'
import log from '../log/logger'

log.info(process.env.REACT_APP_STAGE, 'environment')

export default {
  ...Local
}
